export default [
  {
    label: 'DEALER',
    value: 'DEALER',
  },
  {
    label: 'RBU',
    value: 'RBU',
  },
  {
    label: 'CMM',
    value: 'CMM',
  },
  {
    label: 'ADMIN_RBU',
    value: 'ADMIN_RBU',
  },
  {
    label: 'ADMIN_DEALER',
    value: 'ADMIN_DEALER',
  },
  {
    label: 'ADMIN',
    value: 'ADMIN',
  },
  {
    label: 'CEC',
    value: 'CEC',
  },
  {
    label: 'CRO',
    value: 'CRO',
  },
]
